<template>
  <div>
    <HeaderEntry v-if="!isWebView()"></HeaderEntry>
    <router-view></router-view>
    <div class="container _textright">
      <BtnPagetop></BtnPagetop>
    </div>
    <FooterEntry></FooterEntry>
  </div>
</template>

<script>
import { isWebView } from "@/utils/UserAgent";
import {
  setSctvTag,
  setAffiliateTag,
  setDlpoTag,
} from "@/utils/ExternalScripts";
import HeaderEntry from "@/components/globals/HeaderEntry";
import FooterEntry from "@/components/globals/FooterEntry";
import BtnPagetop from "@/components/button/BtnPagetop";

export default {
  name: "EntryLayout",
  components: {
    HeaderEntry: HeaderEntry,
    FooterEntry: FooterEntry,
    BtnPagetop,
  },
  mounted: function () {
    if (
      !window.__PRERENDER_INJECTED ||
      !window.__PRERENDER_INJECTED.isPrerendering
    ) {
      this.$gtm.enable(true);
      setSctvTag(this.$route.name);
      setDlpoTag(this.$route.name);
    }
    try {
      setAffiliateTag(this.$route.name);
    } catch (e) {
      this.goToErrorPage(e);
    }
  },
  updated: function () {
    setSctvTag(this.$route.name);
    setDlpoTag(this.$route.name);
    try {
      setAffiliateTag(this.$route.name);
    } catch (e) {
      this.goToErrorPage(e);
    }
  },
  methods: {
    isWebView: function () {
      return isWebView();
    },
  },
};
</script>

<style scoped></style>
